class filmStrip {
  constructor(id, frames, duration) {
    const spriteFrames = [
      { transform: 'translateY(0)' },
      { transform: 'translateY(-100%)' }   
    ];
    this.element = document.getElementById(id);
    this.animation = this.element.animate(
    spriteFrames, {
      easing: `steps(${frames}, end)`,
      direction: "normal",
      duration: duration,
      playbackRate: 1,
      iterations: Infinity
    });
    this.pause();
    this.element.addEventListener("mouseenter", () => this.play());
    this.element.addEventListener("mouseleave", () => this.pause());
  }
  pause() { this.animation.pause(); this.animation.currentTime = 0; }
  play() { this.animation.play(); }
}

//const yoga = new filmStrip('yoga-animation', 31, 1000);